<template>
  <DsLayout>
    <template #header>
      <DsNavBar>
        {{ title }}
        <template #left>
          <DsNavButton v-if="backBtnIsShown" @click="backFn">
            <DsIconBack/>
          </DsNavButton>
        </template>
      </DsNavBar>
    </template>
    <slot></slot>
 </DsLayout>
</template>

<script setup>
import { DsIconBack, DsLayout, DsNavBar, DsNavButton } from '@ds/vue2'
import useHeader from '@/composables/useHeader'

const { backFn, backBtnIsShown, title } = useHeader()

</script>
